module.exports = __webpack_public_path__ + "img/header-logo-icon.88b877a9.png";